// Хелпер: дістає дані форварду з res
export function extractForward(res: any) {
  const fwd = res?.outMessage?.fwd_from;
  const replay = res?.outMessage?.reply_to?.reply_to_msg_id;
  if (replay) return { reply_to_msg_id: replay };
  if (!fwd) return {};

  const fwd_message: string | undefined = res?.outMessage?.message ?? undefined;
  const fwd_name: string | undefined = fwd?.from_name?.value ?? undefined;
  const fwd_date: string | undefined = fwd?.date ? String(fwd.date) : undefined;
  const reply_to_msg_id: string | undefined = res?.outMessage?.reply_to?.reply_to_msg_id
    ? res?.outMessage?.reply_to?.reply_to_msg_id
    : undefined;

  // медіа, що прийшло у форварді (звичайно це res.media.*)
  const doc = res?.outMessage?.media?.document;
  const photo = res?.outMessage?.media?.photo_FLAGPHOTO;

  let fwd_hash_img: string | undefined;
  let fwd_type: string | undefined;
  let fwd_mime_type: string | undefined;
  let fwd_file_name: string | undefined;

  if (doc?.access_hash) {
    fwd_hash_img = String(doc.access_hash);
    fwd_type = doc.mime_type; // напр. "image/png" | "application/pdf"
    fwd_file_name = doc.attributes?.[0]?.file_name;
  } else if (photo?.access_hash) {
    fwd_hash_img = String(photo.access_hash);
    fwd_type = photo.predicate_name; // "photo"
    // у фото зазвичай нема mime_type/file_name
  }

  return {
    fwd_message,
    fwd_name,
    fwd_date,
    fwd_hash_img,
    fwd_type,
    fwd_mime_type,
    fwd_file_name,
    reply_to_msg_id,
  };
}
